import { gql } from '@apollo/client';

const CLASSROOM_ROLE_FRAGMENT = gql`
  fragment BaseClassroomRole on ClassroomRole {
    id
    name
    displayName
    classification
    appId
    organizationId
  }
`;

export default CLASSROOM_ROLE_FRAGMENT;
